import { compareAsc } from "date-fns";

export const isDateAfterToday = (value: Date | null | undefined) => {
  if (value) {
    const result = compareAsc(value, new Date());
    return result === 1 ? true : false;
  }
};
